import {useState, useRef} from "react";
import {Flex} from "@mantine/core";
// import UserInput from "../sliceChatComponents/UserInput";
import IconArrowRight from "../../../assets/arrow-right.svg?react";
// Contextual suggestions temporarily disabled
// import {
//     ContextualSuggestionsDropdown,
//     ContextualSuggestionsDropdownHandle,
// } from "./ContextualSuggestionsDropdown";
import {TopCommandInput} from "./TopCommandInput";
import {
    PendingPasteAttachment,
    SubmitWithAttachments,
} from "../utils/pasteAttachments";

interface TopSplashInputProps {
    onSendMessage: SubmitWithAttachments;
    onValueChange: (value: string) => void;
    value?: string;
    showKaiBranding?: boolean;
    compact?: boolean;
}
export const TopSplashInput = ({
    onSendMessage,
    onValueChange,
    value,
    showKaiBranding = false,
    compact = false,
}: TopSplashInputProps) => {
    // Contextual suggestions temporarily disabled
    // const dropdownRef = useRef<ContextualSuggestionsDropdownHandle>(null);

    const handleSubmit = (
        _message: string,
        attachments: PendingPasteAttachment[]
    ) => {
        if (!value || value.trim() === "") {
            return false;
        }

        if (onSendMessage(value, attachments) === false) {
            return false;
        }
        onValueChange("");
        return true;
    };

    // Contextual suggestions temporarily disabled
    // const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    //     // Pass keyboard events to the dropdown
    //     dropdownRef.current?.handleKeyDown(event);
    // };

    // const handleSuggestionSelect = () => {
    //     // Clear the input when a suggestion is selected
    //     onValueChange("");
    // };

    return (
        <Flex direction="column" pos="relative">
            <TopCommandInput
                variant="splash"
                disabled={false}
                value={value ?? ""}
                onChange={onValueChange}
                onSendMessage={handleSubmit}
                showKaiBranding={showKaiBranding}
                compact={compact}
                // onKeyDown={handleKeyDown}
            />
            {/* Contextual suggestions temporarily disabled */}
            {/* <ContextualSuggestionsDropdown
                ref={dropdownRef}
                query={value || ""}
                onSuggestionSelect={handleSuggestionSelect}
            /> */}
        </Flex>
    );
};
